// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content::part(scroll) {
  display: flex;
  flex-direction: column;
}

.form {
  flex: 1;
  overflow-y: scroll;
  padding: 20px;
}

ion-textarea {
  --highlight-height: 0;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding: 30px;
}

.note-button {
  width: 20%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ril-viewer/ril-notes/ril-notes.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;;AACA;EACI,OAAA;EACA,kBAAA;EACA,aAAA;AAEJ;;AAAA;EACI,qBAAA;AAGJ;;AAAA;EACI,aAAA;EACA,yBAAA;EACA,aAAA;AAGJ;;AAAA;EACI,UAAA;AAGJ","sourcesContent":["ion-content::part(scroll) {\n    display: flex;\n    flex-direction: column;\n}\n.form {\n    flex: 1;\n    overflow-y: scroll;\n    padding: 20px;\n}\nion-textarea {\n    --highlight-height: 0;\n}\n\n.button-container {\n    display: flex;\n    justify-content: flex-end;\n    padding: 30px;\n}\n\n.note-button {\n    width: 20%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
